import { useNavigate } from "react-router-dom";
import "./GettingStartedShared.css";

const General1 = () => {
    const navigate = useNavigate();

    const relatedArticles = [
        {
            title: "Can a Non-US Resident or Non-US Citizen Incorporate in the US?",
            description: "Learn about the requirements and process for non-residents to incorporate in the US.",
            link: "/can-a-non-us-resident-or-non-us-citizen-incorporate-in-the-us"
        },
        {
            title: "6 reasons why your startup should be incorporated in the US",
            description: "Discover the key benefits of incorporating your startup in the United States.",
            link: "/why-should-your-startup-incorporate-in-the-usa"
        },
        {
            title: "What Are the Ongoing Compliance Requirements After US Incorporation?",
            description: "Understand the legal and tax obligations for maintaining your US business entity.",
            link: "/what-are-the-ongoing-compliance-requirements-after-us-incorporation?"
        }
    ];

    return (
        <div className="gs-container">
            <header className="gs-header">
                <div className="gs-container-1200">
                </div>
            </header>
            
            <main className="gs-main-content">
                <div className="gs-container-1200">
                    <nav className="gs-breadcrumb">
                        <ol>
                            <li><a href="/help">Help Center</a></li>
                            <li><a href="/getting-started">Getting Started</a></li>
                            <li>General</li>
                        </ol>
                    </nav>

                    <article className="gs-article">
                        <header className="gs-article-header">
                            <h1 className="gs-article-title">How the USA Incorporation Process Works</h1>
                            <div className="gs-article-meta">
                                <span>Posted by BooksComply Team</span>
                                <span>•</span>
                                <span>Last updated August 2025</span>
                            </div>
                        </header>
                        
                        <div className="gs-article-content">
                            <p>
                                Starting a business in the USA involves several key steps. Our firm makes the incorporation process easy and hassle-free. Here's how it works:
                            </p>

                            <h2>Step 1: Choose Your Business Structure</h2>
                            <p>
                                The first step is deciding on the right business entity. The most common options are:
                            </p>
                            <ul className="gs-tips-list">
                                <li><b>LLC (Limited Liability Company):</b> Best for small businesses and startups, offering flexibility and personal asset protection.</li>
                                <li><b>C-Corporation (C-Corp):</b> Ideal for businesses planning to raise capital or go public.</li>
                                <li><b>S-Corporation (S-Corp):</b> Suitable for small businesses looking for tax benefits (subject to IRS eligibility).</li>
                            </ul>
                            <p>We help you choose the best structure based on your business goals.</p>

                            <h2>Step 2: Select Your State of Incorporation</h2>
                            <p>
                                You can incorporate in any US state, but most businesses choose either:
                            </p>
                            <ul className="gs-tips-list">
                                <li><b>Delaware:</b> Known for its business-friendly laws and Court of Chancery.</li>
                                <li><b>Wyoming:</b> Offers strong asset protection and privacy benefits.</li>
                                <li><b>Your Home State:</b> If you're already operating in a specific state.</li>
                            </ul>
                            <p>We'll guide you in selecting the best state for your needs.</p>

                            <h2>Step 3: Choose a Business Name</h2>
                            <p>
                                Your business name must be unique and comply with state requirements. We'll help you:
                            </p>
                            <ul className="gs-tips-list">
                                <li>Conduct a name availability search</li>
                                <li>Register your business name</li>
                                <li>File for a "Doing Business As" (DBA) if needed</li>
                            </ul>

                            <h2>Step 4: Prepare and File Formation Documents</h2>
                            <p>
                                We'll prepare and file all necessary documents with the state, including:
                            </p>
                            <ul className="gs-tips-list">
                                <li>Articles of Incorporation (for corporations)</li>
                                <li>Articles of Organization (for LLCs)</li>
                                <li>Operating Agreement or Bylaws</li>
                            </ul>

                            <h2>Step 5: Obtain an EIN (Employer Identification Number)</h2>
                            <p>
                                An EIN is like a social security number for your business and is required for:
                            </p>
                            <ul className="gs-tips-list">
                                <li>Opening a business bank account</li>
                                <li>Hiring employees</li>
                                <li>Filing business tax returns</li>
                            </ul>
                            <p>We'll obtain your EIN from the IRS on your behalf.</p>

                            <h2>Step 6: Maintain Compliance</h2>
                            <p>
                                After incorporation, you'll need to maintain compliance with state and federal requirements, including:
                            </p>
                            <ul className="gs-tips-list">
                                <li>Annual reports</li>
                                <li>Business licenses and permits</li>
                                <li>Tax filings</li>
                            </ul>
                            <p>We offer ongoing compliance services to keep your business in good standing.</p>

                            <div className="gs-note">
                                <h4>Important Note:</h4>
                                <p>
                                    The entire incorporation process typically takes 1-2 weeks, but expedited processing is available for an additional fee.
                                </p>
                            </div>
                        </div>
                    </article>
                    
                    {/* <div className="gs-helpful-section">
                        <h3 className="gs-helpful-title">Was this article helpful?</h3>
                        <div className="gs-helpful-buttons">
                            <button className="gs-helpful-btn positive">
                                <FaCheckCircle /> Yes, it was helpful
                            </button>
                            <button className="gs-helpful-btn negative">
                                <FaTimesCircle /> No, I need more help
                            </button>
                        </div>
                    </div> */}
                    
                    <div className="gs-related-articles">
                        <h2 className="gs-related-title">Related Articles</h2>
                        <div className="gs-related-grid">
                            {relatedArticles.map((article, index) => (
                                <a 
                                    key={index} 
                                    href={article.link} 
                                    className="gs-related-card"
                                    onClick={(e) => {
                                        e.preventDefault();
                                        navigate(article.link);
                                    }}
                                >
                                    <h3>{article.title}</h3>
                                    <p>{article.description}</p>
                                </a>
                            ))}
                        </div>
                    </div>
                </div>
            </main>
        </div>
    );
};

export default General1;